import * as React from "react";
import BaseCarousel from "./BaseCarousel";
import { MangoBlockProps } from "@/types/general";

export default function CarouselWidget({ block, ...rest }: MangoBlockProps) {
    let widget = (rest as any)?.widget;
    if (!block && !(rest as any)?.widget) return;
    if (block) widget = block.getMainWidget();
    else widget = (rest as any)?.widget;
    if (!widget) return;
    const { title, posts, moreLink } = widget;

    return (
        <BaseCarousel
            title={title}
            posts={posts}
            navigationDots="top"
            moreLink={moreLink}
            widget={widget}
            {...rest}
        />
    );
}
